export const LOGIN_POLICY_LIST_ITEM_TEST_ID = "login-policy-list-item";
